import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/inventoryUsageReport'
import Component from 'components/Reports/InventoryUsageReport'

export default createListViewContainer({ actions, selectors: selectors.inventoryUsageReport })(Component)
